<template>
  <el-drawer :visible="visible" title="添加标签" @close="close">
    <el-checkbox-group v-model="checkedCities">
      <el-checkbox v-for="(item, index) in lableList" :label="item.id" :key="index" class="checkbox">{{ item.name
        }}</el-checkbox>
    </el-checkbox-group>
    <div class="btn">
      <el-button type="primary" @click="save">
        保存
      </el-button>
    </div>
  </el-drawer>
</template>

<script>
import * as taskApi from '../../../api/task.js'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'itemDialogLabel',
  props: {
    taskId: {
      type: [Number, String],
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      lableList: [],
      checkedCities: []
    }
  },
  computed: {
    ...mapGetters([
      'taskLabel'
    ])
  },
  watch: {
    taskLabel(val) {
      if (val.length) {
        this.checkedCities = val.map(item => {
          return item.id
        })
      }
    }
  },
  created() {
    taskApi.getAllLabel(this.taskId).then(res => {
      this.$set(this, 'lableList', res.data)
      res.data.forEach(item => {
        if (item.isSelect == 1) this.checkedCities.push(item.id)
      })
    })
  },
  methods: {
    ...mapActions([
      'getTaskLabel'
    ]),
    close() {
      this.$emit('hide')
    },
    save() {
      const ops = {
        taskId: this.taskId,
        labels: this.checkedCities.join(',')
      }
      taskApi.setTaskLabel(ops).then(res => {
        if (res.code === '00') {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.getTaskLabel({ taskId: this.taskId })
          this.close()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  margin-right: 100px;
  margin-bottom: 60px;
}

.btn {
  text-align: right;
}
</style>
